import { Controller, useFormContext, useWatch } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { Label, TextField } from "@towersystems/roam-common-native";
import { ProductFormValues, FormInputProps } from "../../types";
import { useTranslation } from "../../../../../../utilities/i18n";
import { LllmQuickWinButton } from "../../../../../../components/LlmQuickWinButton";
import { useLlmQuickWinsProvider } from "../../../../../../utilities/llm-quick-wins";

export type NameFormInputProps = FormInputProps & {
  onProductNameLlmQuickWinButtonPress?: () => void;
};

export const NameFormInput = ({
  onProductNameLlmQuickWinButtonPress,
}: NameFormInputProps) => {
  const { control, watch } = useFormContext<ProductFormValues>();
  const { t } = useTranslation("product");
  const { strategyEnabled } = useLlmQuickWinsProvider();

  const globalDisable = useWatch({ control, name: "globalDisable" });
  const nameValue = watch("name");

  return (
    <View>
      <Label required label={t("form.name.label")}>
        {onProductNameLlmQuickWinButtonPress &&
        strategyEnabled("product_seo_friendly_name_quick_win") ? (
          <View style={{ marginLeft: 8 }}>
            <LllmQuickWinButton
              onPress={onProductNameLlmQuickWinButtonPress}
              disabled={!nameValue}
              hoverText="Generate SEO friendly name with AI"
            />
          </View>
        ) : null}
      </Label>
      <Controller
        name="name"
        control={control}
        disabled={globalDisable}
        render={({
          field: { onChange, value, onBlur, disabled },
          fieldState: { error },
        }) => (
          <TextField
            onBlur={onBlur}
            value={value ?? ""}
            readonly={disabled}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.name.placeholder")}
          />
        )}
      />
    </View>
  );
};
